import { render, staticRenderFns } from "./CumplimientoProveedore.vue?vue&type=template&id=2fb93812&scoped=true"
import script from "./CumplimientoProveedore.vue?vue&type=script&lang=js"
export * from "./CumplimientoProveedore.vue?vue&type=script&lang=js"
import style0 from "./CumplimientoProveedore.vue?vue&type=style&index=0&id=2fb93812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb93812",
  null
  
)

export default component.exports